import { cn } from '@/lib/cn';
import { WHATSAPP_URL } from '@/lib/brand';
import { t } from '@/i18n';

/**
 * Sağ altta sabit duran WhatsApp düğmesi — kurumsal sitedeki ile aynı ikon,
 * aynı numara ve aynı davranış (müşteri isteği, 21.09.2026).
 *
 * `raised`: çerez bandı açıkken bandın "Anladım" düğmesinin üstüne binmesin diye
 * yukarı kalkar. Bant kapanınca kendi köşesine iner.
 */
export function WhatsAppButton({ raised = false }: { raised?: boolean }) {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('common.whatsapp')}
      className={cn(
        'fixed right-4 z-50 h-14 w-14 rounded-full drop-shadow-lg transition hover:scale-105 sm:right-5 sm:h-16 sm:w-16',
        raised ? 'bottom-28 sm:bottom-24' : 'bottom-4 sm:bottom-5',
      )}
    >
      <img src="/whatsapp.webp" alt="" width={64} height={64} className="h-full w-full" />
    </a>
  );
}
